import TrovaCollegaComponent from "../../components/TrovaCollega/TrovaCollegaComponent";

export default function TrovaCollega() {

    return (
        <TrovaCollegaComponent></TrovaCollegaComponent>
    )
}